import AuthService from "./AuthService";
import RestService from "./RestService";


export function defineApiService() {
  return {
    auth: new AuthService('login'),
    users: new RestService<any>('users'),
    files: new RestService<any>('files'),
    lessons: new RestService<any>('lessons'),
    lessonStudents: new RestService<any>('lesson-students'),
    lessonTeachers: new RestService<any>('lesson-teachers'),
    lessonVideos: new RestService<any>('lesson-videos'),
    forgotPassword: new RestService<any>('forgot-password'),
    versions: new RestService<any>('app-versions'),
    lessonQuestion: new RestService<any>('questions'),
    units: new RestService<any>('units'),
    contacts: new RestService<any>('contacts'),
    notifications: new RestService<any>('notifications'),
    chatParticipants: new RestService<any>('chat-participants'),
    gifts: new RestService<any>('gifts'),
    giftTypes: new RestService<any>('gift-types'),
    graduations: new RestService<any>('graduations'),
    plans: new RestService<any>('plans'),
    payments: new RestService<any>('transactions'),
    guest: new RestService<any>('guest'),
    coach: new RestService<any>('coach'),
    usersCoachRequest: new RestService<any>('users/coach-requests'),
    recurring: new RestService<any>('recurring'),
  };
}

const apiService = defineApiService();

export type ApiService = ReturnType<typeof defineApiService>;

export function apiRequest() {
  return {
    apiService,
  };
}
